import getHelper from '../../../services/getHelper';
import { TrackingEvent } from '../types';

export default getHelper<TrackingEvent>('/tracking-events/:id');
